import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorun, toJS, extendObservable } from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, SelectInput, TextInput, CheckBoxInput } from '../Form';
import { timezones } from '../../libs/date';

@inject('dataOriginStore', 'dataSourceStore')
@observer
class DataSourceOriginEdit extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug;
  @observable dataOrigin = {
    data_source_id: 0,
    code: '',
    timezone: '',
    block: 0,
  };
  dispose;

  title = 'Edit Data Origin';

  constructor(props) {
    super(props);
    this.init();
  }

  @action init = () => {
    const { params: { id, dataOriginId }, dataOriginStore } = this.props;
    this.slug = `/daq/data-source/${id}/data-origin`;
    this.dispose = autorun(() => {
      if (!this.dataOrigin.data_source_id) {
        this.dataOrigin.data_source_id = id;
        const dataOrigin = dataOriginStore.items.find(item => +item.id === +dataOriginId);
        1        // this.dataOrigin = extendObservable(toJS(this.dataOrigin), toJS(dataOrigin));
        this.dataOrigin = {
          data_source_id: dataOrigin.data_source_id,
          code: dataOrigin.code,
          timezone: dataOrigin.timezone,
          block: dataOrigin.block || 0,
        };
      }
      // console.log('this.dataOrigin', this.dataOrigin);
      // console.log('dataOriginStore.items', dataOriginStore.items);
    });
  };

  componentWillUnmount() {
    this.dispose();
  }

  // @action onChangeCode = (e) => { this.dataOrigin.code = e.target.value; }
  @action onChangeCode = (e) => { this.dataOrigin.code = e.target.value; }
  @action onChangeTimezone = (e) => { this.dataOrigin.timezone = e.target.value; }

  @action handleSave = (e) => {
    e.preventDefault();

    const { notify } = this.context;
    const { params: { id, dataOriginId }, dataOriginStore, dataSourceStore } = this.props;
    const { code, timezone, block } = this.dataOrigin;

    dataOriginStore
      .updateItem({ id: dataOriginId, code, timezone, block })
      .then(() => {
        dataSourceStore.items.filter(ds => ds.id == id)[0].origins.filter(ds => ds.id == dataOriginId)[0].code = code;
        dataSourceStore.items.filter(ds => ds.id == id)[0].origins.filter(ds => ds.id == dataOriginId)[0].timezone = timezone;
        this.context.router.push(this.slug);
        notify.success({ message: 'Updated Data Origin' });
      })
      .catch(action((err) => { notify.error(err); }));
  };

  render() {
    const { params: { id }, dataOriginStore } = this.props;

    if (dataOriginStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={dataOriginStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Code'} value={this.dataOrigin.code} onChange={this.onChangeCode} />
            <SelectInput
              label={'Timezone'}
              fields={{ label: 'offset', value: 'offset' }}
              options={timezones}
              onChange={this.onChangeTimezone}
              value={this.dataOrigin.timezone}
            />
            <CheckBoxInput
              label={'Block'}
              checked={+this.dataOrigin.block === 1}
              onChange={e => this.dataOrigin.block = ~this.dataOrigin.block + 2}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


export default DataSourceOriginEdit;



// WEBPACK FOOTER //
// ./src/components/DataSource/DataSourceOriginEdit.js